import { Injectable } from '@angular/core';
import { Field } from 'app/interfaces/fields';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnlineContractEventEmitterService {
    private aysncFieldsDataSubject = new Subject<Field>();

    aysncFieldsData$ = this.aysncFieldsDataSubject.asObservable();

    updateFieldData(field: Field) {
        this.aysncFieldsDataSubject.next(field);
    }
}